var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailwindLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 120,
    viewBox: "0 0 199 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tailwind-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 56",
    d: "M94.6838 0.124953C63.4358 1.65451 52.3933 27.1527 50.2788 39.4948C69.8264 13.9982 91.4728 25.2779 99.8526 34.1049C110.002 44.4161 115.751 49.2592 117.474 50.2747C130.631 58.0294 135.095 59.8828 149.661 59.8828C183.024 59.8828 199 36.214 199 21.4503C180.909 46.7595 157.917 34.1049 149.661 25.1998C133.497 7.76455 123.347 4.62333 119.823 3.17142C111.13 -0.409962 99.3827 -0.105055 94.6838 0.124953Z",
    fill: "url(#paint0_linear_35_209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 57",
    d: "M44.405 60.2421C13.157 61.7717 2.11452 87.2699 0 99.612C19.5476 74.1153 41.194 85.3951 49.5738 94.2221C59.7235 104.533 65.4719 109.376 67.1948 110.392C80.3518 118.147 84.8158 120 99.3825 120C132.745 120 148.721 96.3312 148.721 81.5675C130.63 106.877 107.639 94.2221 99.3825 85.317C83.2182 67.8817 73.0685 64.7405 69.5443 63.2886C60.8512 59.7072 49.1039 60.0121 44.405 60.2421Z",
    fill: "url(#paint1_linear_35_209)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_209",
    x1: 98.208,
    y1: 17.8102,
    x2: 177.089,
    y2: 50.9973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_209",
    x1: 27.7237,
    y1: 67.2569,
    x2: 120.679,
    y2: 110.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindLogo);
export default __webpack_public_path__ + "static/media/tailwind-logo.c4a97d403c890e2789b182bdc86c8793.svg";
export { ForwardRef as ReactComponent };